import fetcher from 'request/articles/fetch-articles'

export default function Articles() {
  const { state, mutate } = useStatic({
    records: [],
    fetching: true
  })

  useBodyScroll({
    state,
    mutate,
    fetcher
  })

  const t = useI18n()

  return (
    <div>
      <div className='container mb-12'>
        <div className='py-6'>
          <C.Breadcrumb list={ [{ name: t('common:breadcrumb.article') }] }/>
        </div>
        <div className={ cn('py-5 w-full', { hidden: !state.fetching }) }>
          <C.Loading />
        </div>
        <div className='flex flex-wrap'>
          { state.records.map(article => (
            <Article
              key={ article.slug }
              article={ article }
            />
          ))}
        </div>
      </div>
    </div>
  )
}

const Article = ({ article }) => (
  <div className='md:w-1/2 xl:w-1/3 md:p-2'>
    <C.Link
      href={
        h.path
          .article({ slug: article.slug })
      }
      noUnderline
    >
      <C.Image src={ article.cover } className='pt-[60%]'/>
      <div className='py-5'>
        <div className='text-[1rem] font-medium'>{ article.title }</div>
        <div className='text-xs text-gray-500 py-1'>{ article.date.ymd() }</div>
        <div className='text-xs text-gray-700 py-2' dangerouslySetInnerHTML={ { __html: article.description } } />
      </div>
    </C.Link>
  </div>
)
